import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const badges = [
    {
      icon: "Shield",
      text: "256-bit SSL Encryption",
      color: "text-success"
    },
    {
      icon: "Lock",
      text: "GDPR Compliant",
      color: "text-primary"
    },
    {
      icon: "CheckCircle",
      text: "Verified by NYSC",
      color: "text-accent"
    },
    {
      icon: "Database",
      text: "Secure Data Storage",
      color: "text-secondary"
    }
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-6 py-8 border-t border-border">
      {badges?.map((badge, index) => (
        <div key={index} className="flex items-center gap-2">
          <Icon name={badge?.icon} size={20} className={badge?.color} />
          <span className="text-sm text-muted-foreground">{badge?.text}</span>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;